/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 座席属性
 */
export interface UpdateServicesRequestSeatsSeatReservationInnerAttributeRequest {
  /**
   * 種類<br/> NSSA：通路側<br/> NSSW：窓側
   */
  type: UpdateServicesRequestSeatsSeatReservationInnerAttributeRequest.TypeEnum;
}
export namespace UpdateServicesRequestSeatsSeatReservationInnerAttributeRequest {
  export type TypeEnum = 'NSSA' | 'NSSW';
  export const TypeEnum = {
    Nssa: 'NSSA' as TypeEnum,
    Nssw: 'NSSW' as TypeEnum,
  };
}
